import { render, staticRenderFns } from "./DidYouKnowList.vue?vue&type=template&id=6b7155cd&scoped=true&"
import script from "./DidYouKnowList.vue?vue&type=script&lang=js&"
export * from "./DidYouKnowList.vue?vue&type=script&lang=js&"
import style0 from "./DidYouKnowList.vue?vue&type=style&index=0&id=6b7155cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7155cd",
  null
  
)

export default component.exports